import React from "react";
import Product from "./Product";
import "./Home.css";

function Home() {
  return (
    <div className="home">
      <div className="home__header">
        <h1 className="heading__line">
          Learn experiments virutally with online simulations.
        </h1>
      </div>

      <div className="home__row">
        <Product
          title="PHYSICS"
          image={
            "https://images.pexels.com/photos/714699/pexels-photo-714699.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          }
          page="/experimentlist"
        />
         <Product
          title="CHEMISTRY"
          image={
            "https://images.pexels.com/photos/2280571/pexels-photo-2280571.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          }
          page="/experimentlist_chemistry"
        />
        <Product
          title="BIOLOGY"
          image={
            "https://images.pexels.com/photos/3938023/pexels-photo-3938023.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          }
          page="/experimentlist_biology"
        />
      </div>

      


    </div>
  );
}

export default Home;
